import { decodeJWT } from 'utils/hooks';
import {
  CANCEL_SEARCH,
  FEEBACK_MODAL,
  FEEDBACK_ERROR,
  RESET_COMPLETE_GRAPH,
  SET_CONNECTION,
  SET_TOKEN,
  INDIVDUAL_FILTERS,
  SHOW_FLAG_MODAL,
  HIDE_FLAG_MODAL,
  FLAG_ERROR,
  SHOW_EDGE_FLAG_MODAL,
  HIDE_EDGE_FLAG_MODAL,
  EDGE_FLAG_ERROR,
  TOGGLE_FAVORITE,
  SET_FAVORITES,
  SET_ERROR,
  CLEAR_ERROR,
  SET_SEARCH_MODE,
  SET_FILTER_SESSION,
  CLEAR_FILTER_SESSION,
} from './constants';

export const initialState = {
  token: '',
  refreshToken: '',
  expires: '',
  username: '',
  connection: null,
  showFeedbackModal: false,
  feedbackOption: null,
  feedbackError: '',
  cancelSearch: false,
  showIndividualFilters: undefined,
  feedbackImageUrl: null,
  flagModal: {
    isOpen: false,
    nodeId: null,
    nodeName: '',
    nodeType: '',
    success: null,
  },
  flagError: null,
  edgeFlagModal: {
    isOpen: false,
    edgeId: null,
    connectionType: '',
    outV: null,
    inV: null,
    connection: '',
    success: null,
  },
  edgeFlagError: null,
  favorites: [],
  error: null,
  searchMode: 'Nodes',
  filterSession: null,
};

export const coreReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TOKEN: {
      const { payload } = decodeJWT(action.token);
      return {
        ...state,
        token: action.token,
        refreshToken: action.refreshToken || state.refreshToken,
        expires: action.expires,
        username: payload.name,
        email: payload.email,
      };
    }
    case SET_CONNECTION: {
      return { ...state, connection: action.connection };
    }
    case SHOW_FLAG_MODAL:
      return {
        ...state,
        flagModal: {
          isOpen: true,
          nodeId: action.payload.nodeId,
          nodeName: action.payload.nodeName,
          nodeType: action.payload.nodeType,
          success: null,
        },
        flagError: null,
      };

    case HIDE_FLAG_MODAL:
      return {
        ...state,
        flagModal: {
          ...state.flagModal,
          isOpen: action.payload === 'success' ? true : false,
          success: action.payload === 'success' ? 'success' : null,
        },
      };

    case FLAG_ERROR:
      return {
        ...state,
        flagError: action.payload,
      };

    case SHOW_EDGE_FLAG_MODAL:
      return {
        ...state,
        edgeFlagModal: {
          isOpen: true,
          edgeId: action.payload.edgeId,
          connectionType: action.payload.connectionType,
          outV: action.payload.outV,
          inV: action.payload.inV,
          connection: action.payload.connection || '',
          success: null,
        },
        edgeFlagError: null,
      };

    case HIDE_EDGE_FLAG_MODAL:
      return {
        ...state,
        edgeFlagModal: {
          ...state.edgeFlagModal,
          isOpen: action.payload === 'success' ? true : false,
          success: action.payload === 'success' ? 'success' : null,
        },
      };

    case EDGE_FLAG_ERROR:
      return {
        ...state,
        edgeFlagError: action.payload,
      };

    case FEEBACK_MODAL: {
      let op = action.option;
      let imageUrl = action.imageUrl;
      if (!action.payload) {
        op = null;
      }
      return {
        ...state,
        showFeedbackModal: action.payload,
        feedbackError: '',
        feedbackOption: op,
        ...(imageUrl && { feedbackImageUrl: imageUrl }),
      };
    }
    case FEEDBACK_ERROR: {
      return { ...state, feedbackError: action.payload };
    }
    case RESET_COMPLETE_GRAPH: {
      return { ...state, showFeedbackModal: false, feedbackError: '', filterSession: null, searchMode: 'Nodes' };
    }
    case CANCEL_SEARCH: {
      return { ...state, cancelSearch: action.payload };
    }
    case INDIVDUAL_FILTERS: {
      return { ...state, showIndividualFilters: action.payload };
    }
    case SET_FAVORITES: {
      return { ...state, favorites: Array.isArray(action.payload) ? action.payload : [] };
    }
    case TOGGLE_FAVORITE: {
      const node = action.payload;
      const exists = state.favorites.some((f) => f.nodeId === node.nodeId);
      const updated = exists
        ? state.favorites.filter((f) => f.nodeId !== node.nodeId)
        : [...state.favorites, node];
      try {
        localStorage.setItem('relbi_user_favorites', JSON.stringify(updated));
      } catch (e) {}
      return { ...state, favorites: updated };
    }
    case SET_ERROR: {
      return {
        ...state,
        error: {
          message: action.payload.message,
          type: action.payload.type || 'unknown',
          timestamp: action.payload.timestamp || Date.now(),
        },
      };
    }
    case CLEAR_ERROR: {
      return {
        ...state,
        error: null,
      };
    }
    case SET_SEARCH_MODE: {
      return { ...state, searchMode: action.payload };
    }
    case SET_FILTER_SESSION: {
      return { ...state, filterSession: action.payload };
    }
    case CLEAR_FILTER_SESSION: {
      return { ...state, filterSession: null };
    }
    default:
      return state;
  }
};

export default coreReducer;
